import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';
import globalStyles from './pc-aside-list.lightDom.css.lit';
import componentStyles from './pc-aside-list.css.lit';
/**
 * The PcAsideList component
 * @element pc-aside-list
 */
@customElement('pc-aside-list')
export class PcAsideList extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  adoptedStylesheets: AdoptedStyleSheets;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  render(): TemplateResult {
    return html`
      <section class="aside-list">
        <div class="aside-list--heading">
          <slot name="heading"></slot>
        </div>
        <div class="aside-list--list">
          <slot name="list"></slot>
        </div>
      </section>
    `;
  }
}
